import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { CAT_REPORT_BASE_PATH } from '../../../../../../../../../features/trade-reporting/cat/cat-report-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/compliance/_compliance/reporting/cat/_cat')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'cat-report-list',
        label: 'Reports',
        to: CAT_REPORT_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
